module.exports = __webpack_public_path__ + "img/process-balance.6eb64a3d.png";